import { render, staticRenderFns } from "./DetailsBasic.vue?vue&type=template&id=4f6188ef&"
import script from "./DetailsBasic.vue?vue&type=script&lang=js&"
export * from "./DetailsBasic.vue?vue&type=script&lang=js&"
import style0 from "./DetailsBasic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports